import styled from 'styled-components'
import { InlineMessage } from 'components/message'

export const Message = styled(InlineMessage)`
    margin-block: -8px 24px;

    &.tight {
        margin-block-start: -16px;
    }
`